import { localStorage } from 'dibs-browser-storage';

const PROJECT_TAG_TRADE_SOURCING_PROMPT_VIEW_COUNT = 'PROJECT_TAG_TRADE_SOURCING_PROMPT_VIEW_COUNT';
const PROJECT_TAG_TRADE_SOURCING_PROMPT_IMPRESSION_CAP = 2;

function getProjectTagSourcingPromptModalViewCount() {
    return localStorage.getItem(PROJECT_TAG_TRADE_SOURCING_PROMPT_VIEW_COUNT) || 0;
}

export function canShowProjectTagSourcingPromptModal() {
    const viewCount = getProjectTagSourcingPromptModalViewCount();
    return viewCount < PROJECT_TAG_TRADE_SOURCING_PROMPT_IMPRESSION_CAP;
}

export function logProjectTagSourcingPromptModalView() {
    const viewCount = getProjectTagSourcingPromptModalViewCount();
    localStorage.setItem(PROJECT_TAG_TRADE_SOURCING_PROMPT_VIEW_COUNT, viewCount + 1);
}
